
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
window.onload = function () {
  window.scrollTo(0, 0);
};


const targets = document.querySelectorAll(".js-click");

targets.forEach(function (target) {
  target.addEventListener("click", (e) => {
    const currentBlock = e.target.closest('.default-hidden');
    const nextBlock = currentBlock.nextElementSibling;

    if (nextBlock && nextBlock.classList.contains('default-hidden')) {
      nextBlock.classList.add('open');
      nextBlock.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

